// Was der Kunde uns ueber seinen eigenen Bedarf gesagt hat — eine Zeile je Kunde
// und Artikel. Nur Modell-@auth auf DemandInputs, deshalb darf hier ueberall `null`
// stehen: ein geleertes Feld ist ein Update wie jedes andere.

const FIELDS = `
  id
  companyId
  itemNumber
  stockQuantity
  stockDate
  plannedOrderDate
  plannedQuantity
  neededByDate
  note
  sourceActivityId
  suppressUntil
  suppressReason
  recordedAt
  createdByUserId
  createdAt
  updatedAt
`;

// Alle Angaben eines Kunden auf einmal: der Bedarfs-Tab braucht sie fuer jede
// Spur, und einzeln waeren es bei 40 Artikeln 40 Abfragen.
export const demandInputsByCompany = /* GraphQL */ `
  query DemandInputsByCompany($companyId: ID!, $limit: Int, $nextToken: String) {
    demandInputsByCompanyIdByItemNumber(
      companyId: $companyId
      limit: $limit
      nextToken: $nextToken
    ) {
      items { ${FIELDS} }
      nextToken
    }
  }
`;

export const createDemandInputs = /* GraphQL */ `
  mutation CreateDemandInputs($input: CreateDemandInputsInput!) {
    createDemandInputs(input: $input) { ${FIELDS} }
  }
`;

export const updateDemandInputs = /* GraphQL */ `
  mutation UpdateDemandInputs($input: UpdateDemandInputsInput!) {
    updateDemandInputs(input: $input) { ${FIELDS} }
  }
`;
